import React from 'react'

const Map = () => {
  return (
    <iframe
      title="google maps"
      src="https://maps.google.com/maps?q=
                  Fairies%20of%20Tranqility&t=&z=13&ie=UTF8&iwloc=&output=embed"
      frameBorder="0"
      scrolling="no"
      marginHeight="0"
      marginWidth="0"
    />
  )
}

export default Map
